import React from "react";
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/solid";
import { ActivityInfoType } from "@api/graphql/generated/generated-types";

interface ActivityIconProps {
  infoType: ActivityInfoType;
  className?: string;
}

export function getActivityIconProps(infoType: ActivityInfoType) {
  switch (infoType) {
    case ActivityInfoType.Success:
      return {
        icon: CheckCircleIcon,
        color: "text-green-500 border-green-200",
      };
    case ActivityInfoType.Warning:
      return {
        icon: ExclamationTriangleIcon,
        color: "text-yellow-500 border-yellow-200",
      };
    case ActivityInfoType.Danger:
      return {
        icon: ExclamationTriangleIcon,
        color: "text-red-500 border-red-200",
      };
    case ActivityInfoType.Info:
    default:
      return {
        icon: InformationCircleIcon,
        color: "text-gray-300 border-gray-200",
      };
  }
}

export function ActivityIcon({ infoType, className }: ActivityIconProps) {
  const { icon: Icon, color } = getActivityIconProps(infoType);
  return <Icon className={`w-5 h-5 ${color} ${className ?? ""}`} />;
}
